/**
 * Moved to shared/src/utils/numericExpression.ts (SOC-5990) so the server-side
 * save gate (services/teacher/refactor/modules/quizzes/utils/numericAnswers.ts)
 * can use the same implementation instead of a twin that drifts — the drift
 * this file's own docblock used to warn about. Re-exported here so every
 * existing editor import keeps working unchanged.
 */
export * from '../../../../../../shared/src/utils/numericExpression';
